

//TEST
/*
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyC7q9XyqpHagFDV2hX1Dy46S_UySzVEnVI",
  authDomain: "login.addressbooktest.gcp.ovs.it",
  databaseURL: "https://ovs-rubricaavanzata-dev.firebaseio.com",
  projectId: "ovs-rubricaavanzata-dev",
  storageBucket: "addressbooktest.gcp.ovs.it",
  messagingSenderId: "766819578476"
};

export const GA_ID= 'UA-111260125-2';
*/
//PRODUZIONE

export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyDJw5qufQoL1v-MWbU2MRiUDOvAhlFvSYw",
  authDomain: "login.addressbook.gcp.ovs.it",
  databaseURL: "https://ovs-rubricaavanzata-prod.firebaseio.com",
  projectId: "ovs-rubricaavanzata-prod",
  storageBucket: "addressbook.gcp.ovs.it",
  messagingSenderId: "106290549970"
};

export const GA_ID= 'UA-111260125-1';



// WEBPACK FOOTER //
// ./src/app/app.firebase.config.ts